import { render, staticRenderFns } from "./TaskOutcomeBox.vue?vue&type=template&id=24433b8a&scoped=true"
import script from "./TaskOutcomeBox.vue?vue&type=script&lang=ts"
export * from "./TaskOutcomeBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24433b8a",
  null
  
)

export default component.exports